import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaYoutube,  } from 'react-icons/fa';
import "./Footer.css";

const Footer = () => {
  return (
    <Container fluid className="footer-section">
      <div className="footer-overlay">
 <img src={require("../assets/icons/image1.png")}
       alt="footer-bg-logo"
       className="footer-bg-logo" />

  <div className="footer-overlay"></div>
        <Row className="footer-content-wrapper">
          {/* Left Column */}
          <Col lg={4} md={12} sm={12} className="footer-column-wrapper">
            <div className="footer-left">
              {/* <img src={require("../assets/ongc-logo1.jpg")} alt="logo" className="footer-logo" /> */}
                <img src={require("../assets/ONGC LOGO 11.png")} alt="logo" className="footer-logo" />
              <div className="footer-trust-text">
                <h2>Making Tomorrow Brighter</h2>
            <p>
  At ONGC Community School, we nurture young minds with innovation, care, and purposeful learning. Through a supportive environment and modern teaching practices, we help students grow into confident, responsible, and future-ready individuals.
</p>
              </div>
              <div className="social-icons">
                <a href="https://www.facebook.com/profile.php?id=100064055612636"><FaFacebook /></a>
                <a href="https://www.instagram.com/ongccommunityschool/"><FaInstagram /></a>
                <a href="https://www.youtube.com/@ONGCCommunitySchool" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
                {/* <a href="https://www.linkedin.com/company/alutuff/"><FaLinkedin /></a> */}
              </div>
            </div>
          </Col>

          {/* Center Column - Quick Links */}
          <Col lg={3} md={6} sm={12} className="footer-column-wrapper">
            <div className="footer-column">
              <div className="col-text-div">
                <h4>Quick Links</h4>
                <div className="footer-links-column">
                  <a href="/home">Home</a>
                  <a href="/about">About Us</a>
                  <a href="/Curriculum">Curriculum</a>
                  <a href="/AcademicsCalendar">Academics Calendar</a>
                  <a href="/Gallery">Gallery</a>
                  <a href="/contact">Contact Us</a>

                </div>
              </div>
            </div>
          </Col>

          {/* Right Column - Contact Info */}
          <Col lg={3} md={5} sm={12} className="footer-column-wrapper">
            <div className="footer-column">
              <div className="col-text-div">
                <h4>Contact Info</h4>
                <div className="footer-contact-info">
                  <p><strong>Address:</strong><br />Vill. Paintala, ,<br />Laharpur, Uttar Pradesh, India.</p>
                  <p><strong>Phone:</strong> <br />
                    <a href="tel:+918009244441"> +91 80092 44441</a>
                  </p>
                  <p><strong>Email:</strong><br />
                    <a href="mailto:xxxxx@alutuff.in">ongc.school@yahoo.com</a>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>

      </div>

      <div className='copyright-div'>
        Copyright © 2026 <span style={{ color: "#ea3138",marginLeft:"2px" }}>ONGC School</span>. All Right Reserved.
      </div>
    </Container>
  );
};

export default Footer;
